import * as React from "react";
import type { SVGProps } from "react";
const SvgBancontactPay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#fff"
      d="M2.84 2.5H20.8c.46 0 .84.37.84.84v13.1H2V3.33c0-.47.37-.84.84-.84"
    />
    <mask
      id="bancontact-pay_svg__a"
      width={9}
      height={4}
      x={11}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M16.58 4.43c-2.38 0-3.57 1.59-4.75 3.17h7.88V4.43z"
      />
    </mask>
    <g mask="url(#bancontact-pay_svg__a)">
      <path
        fill="url(#bancontact-pay_svg__b)"
        d="M19.71 4.43h-7.88V7.6h7.88z"
      />
    </g>
    <mask
      id="bancontact-pay_svg__c"
      width={9}
      height={4}
      x={3}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M3.94 7.6v3.17h3.13c2.38 0 3.57-1.58 4.76-3.17z" />
    </mask>
    <g mask="url(#bancontact-pay_svg__c)">
      <path fill="url(#bancontact-pay_svg__d)" d="M11.83 7.6H3.94v3.17h7.89z" />
    </g>
    <path
      fill="#0b2265"
      d="m5.29 13.2-.17-.06a.4.4 0 0 0 .2-.14q.08-.15.09-.31 0-.15-.08-.28a.5.5 0 0 0-.22-.2 1 1 0 0 0-.33-.07h-.84v2.13h.9q.24 0 .38-.08.15-.1.23-.23a.6.6 0 0 0 .01-.56 1 1 0 0 0-.17-.2m-.37-.61q.06.06.06.17 0 .1-.06.17a.2.2 0 0 1-.16.06h-.4v-.47h.4q.11 0 .16.07m.13 1.17a.3.3 0 0 1-.1.1.3.3 0 0 1-.16.04h-.42v-.55h.42q.1-.01.17.04.07.04.1.1a.3.3 0 0 1 0 .27m1.86-.74-.04-.04a1 1 0 0 0-.19-.14.68.68 0 0 0-.86.32 1 1 0 0 0-.09.4q0 .21.1.39a.7.7 0 0 0 .85.3.5.5 0 0 0 .23-.18v.2h.4v-1.44h-.4zm-.07.72a.4.4 0 0 1-.14.14.4.4 0 0 1-.18.06.4.4 0 0 1-.2-.06.4.4 0 0 1-.13-.14.39.39 0 0 1 .13-.52.4.4 0 0 1 .2-.05q.09 0 .18.05a.4.4 0 0 1 .2.33q0 .1-.06.2m1.97-.88a.6.6 0 0 0-.5-.04 1 1 0 0 0-.18.13l-.07.1v-.23h-.4v1.44h.4v-.75q0-.14.05-.2a.3.3 0 0 1 .13-.11q.07-.04.15-.04t.14.04.1.11a.4.4 0 0 1 .04.18v.77h.4v-.8a1 1 0 0 0-.06-.36.5.5 0 0 0-.2-.24m1.48 1.03a.4.4 0 0 1-.37-.01.4.4 0 0 1-.14-.15.4.4 0 0 1 0-.38.4.4 0 0 1 .34-.2.4.4 0 0 1 .3.15l.3-.21a.7.7 0 0 0-.6-.3 1 1 0 0 0-.4.09 1 1 0 0 0-.29.26 1 1 0 0 0-.1.4q0 .22.1.4.1.16.3.27a.8.8 0 0 0 .73 0 1 1 0 0 0 .26-.22l-.3-.2a.3.3 0 0 1-.13.1m1.7-1.01a1 1 0 0 0-.39-.1.8.8 0 0 0-.66.37 1 1 0 0 0-.11.39.7.7 0 0 0 .39.66q.18.1.38.1a1 1 0 0 0 .39-.1.7.7 0 0 0 .39-.66.7.7 0 0 0-.4-.66m-.07.86a.4.4 0 0 1-.13.14.4.4 0 0 1-.18.05.4.4 0 0 1-.32-.19.4.4 0 0 1-.05-.2.4.4 0 0 1 .05-.2q.04-.09.13-.13a.4.4 0 0 1 .18-.05.4.4 0 0 1 .32.18.4.4 0 0 1 .05.2.4.4 0 0 1-.05.2m1.88-.88a.6.6 0 0 0-.5-.04 1 1 0 0 0-.18.13l-.06.1v-.23h-.4v1.44h.4v-.75q0-.14.05-.2a.3.3 0 0 1 .12-.11q.08-.04.15-.04.08 0 .14.04.06.03.1.11a.4.4 0 0 1 .04.18v.77h.4v-.8a1 1 0 0 0-.06-.36.5.5 0 0 0-.2-.24m1.1-.57h-.4v.53h-.26v.31h.26v1.13h.4v-1.13h.31v-.31h-.3zm1.6.72-.04-.04a1 1 0 0 0-.2-.14.68.68 0 0 0-.86.32 1 1 0 0 0-.08.4q0 .21.1.39a.7.7 0 0 0 .85.3.5.5 0 0 0 .22-.18v.2h.4v-1.44h-.4zm-.07.72a.4.4 0 0 1-.14.14.4.4 0 0 1-.18.06.4.4 0 0 1-.2-.06.4.4 0 0 1-.13-.14.39.39 0 0 1 .13-.52.4.4 0 0 1 .2-.05q.09 0 .18.05a.4.4 0 0 1 .2.33q0 .1-.06.2m1.7.15a.4.4 0 0 1-.37-.01.4.4 0 0 1-.13-.15.4.4 0 0 1 0-.38.4.4 0 0 1 .33-.2.4.4 0 0 1 .3.15l.3-.21a.7.7 0 0 0-.6-.3 1 1 0 0 0-.4.09 1 1 0 0 0-.28.26 1 1 0 0 0-.11.4q0 .22.1.4.12.16.3.27a.8.8 0 0 0 .74 0 1 1 0 0 0 .26-.22l-.3-.2a.3.3 0 0 1-.14.1m1.55-1.07h-.3v-.53h-.4v.53h-.27v.31h.26v1.13h.4v-1.13h.31z"
    />
    <path
      fill="url(#bancontact-pay_svg__e)"
      d="M2 16.43h19.64V19c0 1.39-1.13 2.51-2.51 2.51H2z"
    />
    <path
      fill="#0b2265"
      d="M10.42 17.68c.54 0 .71.39.64.78a.9.9 0 0 1-.92.78h-.5l-.14.84h-.48l.42-2.4zm-.1.43h-.47l-.13.7h.48c.23 0 .35-.18.38-.35s-.03-.35-.25-.35m2.2.34h.46l-.29 1.63h-.46l.05-.23a.8.8 0 0 1-.59.27c-.45 0-.72-.35-.63-.85s.47-.86.94-.86c.21 0 .4.1.48.25zm-.16.82c.05-.25-.12-.43-.35-.43-.24 0-.44.19-.49.43-.04.22.1.43.34.43s.46-.2.5-.43m2.04-.82h.5l-1.44 2.43h-.48l.55-.95-.39-1.48h.5l.22.95z"
    />
    <defs>
      <linearGradient
        id="bancontact-pay_svg__b"
        x1={11.83}
        x2={19.71}
        y1={6.02}
        y2={6.02}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#ff9700" />
        <stop offset={0.75} stopColor="#ffd400" />
        <stop offset={1} stopColor="#ffd400" />
      </linearGradient>
      <linearGradient
        id="bancontact-pay_svg__d"
        x1={3.98}
        x2={11.79}
        y1={9.18}
        y2={9.18}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#0439d1" />
        <stop offset={0.25} stopColor="#0439d1" />
        <stop offset={1} stopColor="#0b2265" />
      </linearGradient>
      <linearGradient
        id="bancontact-pay_svg__e"
        x1={2}
        x2={21.64}
        y1={18.97}
        y2={18.97}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#ff9700" />
        <stop offset={0.75} stopColor="#ffd400" />
        <stop offset={1} stopColor="#ffd400" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgBancontactPay;
